import {SvgIcon, useTheme} from '@mui/material';

export default function MenuIcon() {
	const theme = useTheme();
	return (
		<SvgIcon width="21" height="12" viewBox="0 0 21 12">
			<path fillRule="evenodd" clipRule="evenodd"
			      d="M0.784668 1C0.784668 0.585786 1.12045 0.25 1.53467 0.25H19.5347C19.9489 0.25 20.2847 0.585786 20.2847 1C20.2847 1.41421 19.9489 1.75 19.5347 1.75H1.53467C1.12045 1.75 0.784668 1.41421 0.784668 1Z"
			      fill={theme.palette.primary.main}/>
			<path opacity="0.4" fillRule="evenodd" clipRule="evenodd"
			      d="M7.2749 6C7.2749 5.58579 7.61069 5.25 8.0249 5.25H19.5349C19.9491 5.25 20.2849 5.58579 20.2849 6C20.2849 6.41421 19.9491 6.75 19.5349 6.75H8.0249C7.61069 6.75 7.2749 6.41421 7.2749 6Z"
			      fill={theme.palette.primary.main}/>
			<path opacity="0.4" fillRule="evenodd" clipRule="evenodd"
			      d="M0.784668 6C0.784668 5.58579 1.12045 5.25 1.53467 5.25H4.52467C4.93888 5.25 5.27467 5.58579 5.27467 6C5.27467 6.41421 4.93888 6.75 4.52467 6.75H1.53467C1.12045 6.75 0.784668 6.41421 0.784668 6Z"
			      fill={theme.palette.primary.main}/>
			<path fillRule="evenodd" clipRule="evenodd"
			      d="M0.784668 11C0.784668 10.5858 1.12045 10.25 1.53467 10.25H19.5347C19.9489 10.25 20.2847 10.5858 20.2847 11C20.2847 11.4142 19.9489 11.75 19.5347 11.75H1.53467C1.12045 11.75 0.784668 11.4142 0.784668 11Z"
			      fill={theme.palette.primary.main}/>
		</SvgIcon>
	);
}
